module.exports = __webpack_public_path__ + "img/easymeet_logo-b.f35322e5.svg";